import "vite-dep-pre-bundle-external:/home/ubuntu/bwm-platform/ui_v2/node_modules/react-leaflet-cluster/lib/assets/MarkerCluster.Default.css";